function init(elements) {
    $(elements).each((i, el) => {
        const $el = $(el);
        const $input = $el.find('input');
        const $filename = $el.find('[data-filename]');
        const $filesize = $el.find('[data-filesize]');
        const $formats = $el.find('[data-formats]');

        $formats.text(`(${$input.attr('accept')})`);

        $input.change(function () {
            $el.toggleClass('uploaded', this.files.length > 0);

            if (this.files.length > 0) {
                $filename.text(this.files[0].name);
                $filesize.text(parseFloat(this.files[0].size / (1024 * 1024), 10).toFixed(2));
            }
        });
    });
}

export default function (elements) {
    init(elements);
}

